import React, { Component } from 'react';
import { message, Tabs, Button } from 'antd';
import md5 from "react-native-md5";
import './login.css'
import {
    login,
    getQrCodeInfo,
    getRedirectUrl,
    baseUrl,
    getToken,
    getUrl
} from '../../apis/api'

const { TabPane } = Tabs;

class Login extends Component {

  constructor(props) {
    super(props);
    this.state={
        isShowQrcode:false,
        qrcode_uuid:'',
        qrcode_img:'',
        access_token:'',
        username:'',
        time:null,
        login_flag:'',
        accountNum: '', //账号
        password: '', //密码
        loading:false
    }
}

componentWillMount(){  

    const {isShowQrcode} = this.state;
    if(isShowQrcode){

        // this.getQrcodeInfo();
    }

    this.getUrl()
}

getUrl(){
    getUrl().then( (data)=> {
        if(data.code === 0){
            window.location.href = data.content  // 统一跳转授权登陆页面
        }else{
            message.error(data.message); 
        }
    });
}

changeTabs = (e) =>{
    let isShowQrcode=false;
    if(e==='2'){
        isShowQrcode=true;
    }
    this.setState({isShowQrcode},()=>{

        if(!this.state.isShowQrcode){
            clearInterval(this.timer);
            this.setState({

                accountNum:'',
                password:'',
            })
        }else{

            this.getQrcodeInfo();
        }
    })
}

// 获取到二维码信息
getQrcodeInfo = () =>{

    clearInterval(this.timer);

    this.setState({
        login_flag: '',
    });

    var params = {

        redirect_uri: `${baseUrl}/#/`,
    }

    getQrCodeInfo(params).then((data)=>{
        
        if(data.code === 0){

            this.setState({

                qrcode_img: data.content.qrcode_img,
                qrcode_uuid:data.content.qrcode_uuid

            },()=>{

                this.timer = setInterval(()=>{

                    this.getRedirectUrl();

                },1000)
            })     
        }else{

            message.error(data.message); 
        }
    })
}

// 获取跳转地址
getRedirectUrl = () =>{
    let _this=this;
    const {qrcode_uuid} = this.state;

    var params = {

        qrcode_uuid: qrcode_uuid,
    }

    getRedirectUrl(params).then( (data)=> {

        if(data.code === 0){

            clearInterval(this.timer);

            this.setState({
                login_flag: 3,
            },()=>{
                // window.location.href = data.content.redirect_uri;
                let code=data.content.code;
                _this.getToken(code);
            });

        }else if(data.code === 5016){ //二维码已过期

            clearInterval(this.timer);

            this.setState({
                login_flag: 1,
            });

        }else if(data.code === 5017){ //二维码未扫描

           
        }else if(data.code === 5018){ //二维码已扫描

            this.setState({
                login_flag: 2,
            });

        }else if(data.code === 5013){ // 非法的请求操作

            clearInterval(this.timer);
            this.getQrcodeInfo();

        // }else if(data.code === 5007){  //关键参数不能为空

        //     clearInterval(this.timer);
        //     message.error(data.message);  
        }
    });

}

// 账号改变
onAccountChange = (e) =>{

    this.setState({

        accountNum: e.target.value,
    })

}

// 密码改变
onPasswordChange = (e) =>{

    this.setState({

        password: e.target.value,
    })

}

keyPress = e =>{
    if(e.keyCode==13) {
        this.login();
    }
}

//账号密码登录
login = () =>{
    let _this=this;
    const {

        accountNum,
        password,

    } = this.state;


    if(!accountNum){
    
        return;
    }
    if(!password){
    
        return;
    }

    _this.setState({loading:true})

    var params = {

        username: accountNum,
        password:md5.hex_md5(password),
        redirect_uri:`${baseUrl}/#/`,
        source: 'cgj',
    }

    login(params).then( (data)=> {

        if(data.code === 0){

            // window.location.href = data.content.redirect_uri;
            let code=data.content.code;
            _this.getToken(code);

        }else{
            _this.setState({loading:false})
            message.error(data.message); 
        }
    });
}

getToken(code){
    let _this=this;
    let params={
        code:code,
        source:'cgj'
    }
    getToken(params).then( (data)=> {

        if(data.code === 0){

            let access_token=data.content.access_token;
            sessionStorage.setItem('access_token',access_token);
            _this.setState({loading:false},()=>{
                _this.props.history.push('/home')
            })
        }else{
            _this.setState({loading:false})
            message.error(data.message); 
        }
    });
}

   componentWillUnmount(){
    // 在卸载的时候对所有的操作进行清除
    this.setState = (state,callback)=>{
        return;
      };
   }

  render() {
    
    const {
        login_flag,
        accountNum,
        password,
        loading
    } = this.state;

    return (
      <div className="login_wrapper_header">  {/* 原 className login_wrapper*/}
          {/* 头部logo */}
          {/* <div className="header">
             <div><img src={require("./../../static/images/czy_logo.svg")} alt=''/></div>
             <span></span>
             <p>彩生活物业信息化管理平台</p>
          </div> */}

          {/* 内容框 */}
          {/* <div className="content_wrapper">

             <div className="right_wrapper">
                <div className='title'>
                 <Tabs defaultActiveKey="1" onChange={this.changeTabs}>
                   <TabPane tab="账号登录" key="1">   
                    <div className="account_login">
                         <p>账号</p>
                         <input type="text" value={accountNum} placeholder="请输入您的账号"
                            onChange={this.onAccountChange} onKeyUp={this.keyPress} />
                         <p>密码</p>
                         <input type="password" value={password} placeholder="请输入您的密码"  
                            onChange = {this.onPasswordChange} onKeyUp={this.keyPress} />
                         <input type="button" className="login_btn" value="登录" onClick={this.login} />  隐藏
                         <Button type="primary" className="login_btn" onClick={this.login} loading={loading}>登录</Button>
                    </div> 
                   </TabPane>
                   <TabPane tab="扫码登录" key="2">
                   <div className="qrcode_login">
                     <div className="qrcode">
                     <img src={this.state.qrcode_img} className="qrcode_img" alt='暂无二维码'/>
                     {(login_flag===1||login_flag===2||login_flag===3)?(
                      <div>
                        <div className="mask"></div>
                        {login_flag===1?
                          <div className='home_icon_shuaxin'></div>:(
                            login_flag===2?
                              <div className='home_icon_success'></div>:
                              <div className='login_icon_loading'></div>
                          )
                        }
                      </div>
                      ):''}
                      </div>
                      {login_flag===1?
                       <div>
                         <p>二维码已失效</p>
                         <p className='reload' onClick={this.reload.bind(this)}>点击刷新</p>
                       </div>:(login_flag===2?
                          <div>
                            <p>扫码成功，请在手机端完成操作</p>
                            <p className='warning'>请勿刷新页面</p>
                          </div>:(login_flag===3?
                            <div>
                              <p>正在登录…</p>
                            </div>:
                            <p>打开彩管家，扫一扫登录</p>
                          )
                       )
                      }
                   </div>  
                   </TabPane>
                 </Tabs> 
                </div>           
             </div>
          </div> */}

      </div>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/page/Login/Login.js